import UserManCircleColor from './UserManCircleColour.svg';
import UserManCircleDark from './UserManCircleDark.svg';
import UserManCircleLight from './UserManCircleLight.svg';
export const userManCircle = { color: UserManCircleColor, dark: UserManCircleDark, light: UserManCircleLight };
//# sourceMappingURL=index.js.map